"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var _default = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.FEEDBACK_SUBMISSION],
  objectType: _ObjectTypes.FEEDBACK_SUBMISSION,
  recordName: 'FeedbackSubmissionRecord',
  defaults: {
    associations: (0, _immutable.Map)(),
    objectId: null,
    surveyId: null,
    isDeleted: false,
    portalId: null,
    properties: (0, _immutable.Map)()
  }
}, {
  primary: ['hs_content'],
  secondary: ['hs_survey_type', 'hs_response_group']
});

exports.default = _default;
module.exports = exports.default;